<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img src="static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  import { logout } from '@/services/auth'

  export default {
    name: 'header-dropdown',
    data () {
      return { itemsCount: 42 }
    },
    methods: {
      logout () {
        logout()
          .then(response => {
            this.$router.push('/login')
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue